export const teamStatsData = [
  { value: "10+", label: "Years of Experience" },
  { value: "100+", label: "Projects Delivered" },
  { value: "50+", label: "Clients Worldwide" },
  { value: "6", label: "Core Disciplines" },
];

export const teamFunctionsData = [
  {
    icon: "ri-code-s-slash-line",
    title: "Engineering",
    desc: "Senior Laravel, PHP, Vue.js and Flutter engineers who architect and ship production-grade software.",
  },
  {
    icon: "ri-palette-line",
    title: "Design & UX",
    desc: "Product designers who turn complex workflows into clean, intuitive and consistent interfaces.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Quality Assurance",
    desc: "Dedicated QA engineers who test every release so your product stays stable and reliable.",
  },
  {
    icon: "ri-cloud-line",
    title: "DevOps & Cloud",
    desc: "Infrastructure specialists handling AWS, Docker, CI/CD pipelines and proactive monitoring.",
  },
  {
    icon: "ri-flow-chart",
    title: "Project Management",
    desc: "Delivery leads who keep communication transparent and projects on time and on budget.",
  },
  {
    icon: "ri-sparkling-line",
    title: "AI & Automation",
    desc: "Engineers who bring AI, automation and modern tooling into the products we build.",
  },
];

export const teamValuesData = [
  {
    icon: "ri-lightbulb-line",
    title: "Ownership",
    desc: "Everyone owns their work end to end — from the first commit to the final release.",
  },
  {
    icon: "ri-team-line",
    title: "Collaboration",
    desc: "We solve problems together, pairing across disciplines instead of working in silos.",
  },
  {
    icon: "ri-graduation-cap-line",
    title: "Continuous Learning",
    desc: "We invest time in learning, sharing knowledge and staying current with modern tech.",
  },
  {
    icon: "ri-focus-3-line",
    title: "Craft & Quality",
    desc: "Clean code, thoughtful design and thorough testing are part of every deliverable.",
  },
];

export const lifeBenefitsData = [
  { icon: "ri-home-office-line", title: "Flexible Work", desc: "Hybrid and remote-friendly ways of working that fit your life." },
  { icon: "ri-book-open-line", title: "Learning Support", desc: "Support for courses, certifications and conferences to grow your skills." },
  { icon: "ri-heart-pulse-line", title: "Health & Wellbeing", desc: "Health coverage and generous paid time off to recharge." },
  { icon: "ri-computer-line", title: "Modern Tooling", desc: "Up-to-date hardware and tools so you can do your best work." },
  { icon: "ri-cup-line", title: "Team Culture", desc: "Regular team outings, celebrations and open knowledge-sharing sessions." },
  { icon: "ri-line-chart-line", title: "Growth Path", desc: "Clear roles and regular reviews that support your long-term growth." },
];

export const lifeValuesData = [
  { icon: "ri-user-heart-line", title: "People First", desc: "We look after our people, because great products come from teams that feel supported." },
  { icon: "ri-chat-smile-2-line", title: "Open Communication", desc: "Honest feedback and transparent updates are the default, not the exception." },
  { icon: "ri-compass-3-line", title: "Purpose Driven", desc: "Every project has a clear goal, and every teammate knows how they contribute." },
  { icon: "ri-rocket-line", title: "Always Improving", desc: "We reflect, iterate and get a little better with every release we ship." },
];

export const lifeGalleryData = [
  {
    image: "https://readdy.ai/api/search-image?query=Modern%20open%20plan%20software%20office%20with%20developers%20collaborating%20at%20desks%2C%20warm%20natural%20light%2C%20plants%20and%20clean%20minimal%20interior%20design%2C%20professional%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=astrojal-life-gallery-1&orientation=landscape",
    title: "Where We Work",
    desc: "A calm, modern workspace built for focus and collaboration.",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Software%20team%20in%20an%20informal%20knowledge%20sharing%20session%20around%20a%20whiteboard%20with%20sticky%20notes%2C%20bright%20modern%20office%2C%20warm%20inviting%20atmosphere%2C%20professional%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=astrojal-life-gallery-2&orientation=landscape",
    title: "Knowledge Sharing",
    desc: "Weekly sessions where the team learns from each other.",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Happy%20diverse%20technology%20team%20celebrating%20together%20in%20a%20bright%20modern%20office%2C%20casual%20friendly%20atmosphere%2C%20warm%20natural%20light%2C%20candid%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=astrojal-life-gallery-3&orientation=landscape",
    title: "Celebrations",
    desc: "We celebrate launches, milestones and the people behind them.",
  },
];

export interface HolidayListItem {
  name: string;
  day: string;
  month: string;
  weekday: string;
  type: "National" | "Festival" | "Optional";
  icon: string;
}

export const holidayListData: HolidayListItem[] = [
  { name: "New Year's Day", day: "01", month: "Jan", weekday: "Thursday", type: "Festival", icon: "ri-emotion-happy-line" },
  { name: "Makar Sankranti", day: "14", month: "Jan", weekday: "Wednesday", type: "Festival", icon: "ri-flight-takeoff-line" },
  { name: "Republic Day", day: "26", month: "Jan", weekday: "Monday", type: "National", icon: "ri-flag-2-line" },
  { name: "Maha Shivaratri", day: "15", month: "Feb", weekday: "Sunday", type: "Festival", icon: "ri-moon-line" },
  { name: "Holi", day: "03", month: "Mar", weekday: "Tuesday", type: "Festival", icon: "ri-palette-line" },
  { name: "Id-ul-Fitr", day: "21", month: "Mar", weekday: "Saturday", type: "Festival", icon: "ri-moon-clear-line" },
  { name: "Mahavir Jayanti", day: "31", month: "Mar", weekday: "Tuesday", type: "Festival", icon: "ri-heart-3-line" },
  { name: "Good Friday", day: "03", month: "Apr", weekday: "Friday", type: "Festival", icon: "ri-hand-heart-line" },
  { name: "Dr. Ambedkar Jayanti", day: "14", month: "Apr", weekday: "Tuesday", type: "Optional", icon: "ri-user-star-line" },
  { name: "Labour Day", day: "01", month: "May", weekday: "Friday", type: "Optional", icon: "ri-hammer-line" },
  { name: "Independence Day", day: "15", month: "Aug", weekday: "Saturday", type: "National", icon: "ri-flag-2-line" },
  { name: "Raksha Bandhan", day: "28", month: "Aug", weekday: "Friday", type: "Optional", icon: "ri-hand-heart-line" },
  { name: "Ganesh Chaturthi", day: "14", month: "Sep", weekday: "Monday", type: "Optional", icon: "ri-goblet-line" },
  { name: "Gandhi Jayanti", day: "02", month: "Oct", weekday: "Friday", type: "National", icon: "ri-flag-2-line" },
  { name: "Diwali", day: "08", month: "Nov", weekday: "Sunday", type: "Festival", icon: "ri-fire-line" },
  { name: "Christmas", day: "25", month: "Dec", weekday: "Friday", type: "Festival", icon: "ri-gift-2-line" },
];

export const holidayNotesData = [
  { icon: "ri-smartphone-line", title: "Stay Reachable", desc: "For critical projects, a small on-call rotation stays reachable even on holidays." },
  { icon: "ri-team-line", title: "Team Coverage", desc: "Delivery leads plan timelines around holidays so no client deadline is missed." },
  { icon: "ri-refresh-line", title: "Subject to Change", desc: "Festival dates follow the official government calendar and may be updated." },
];